import { isPcPlatform } from '@office-start/device-detection-utility';
import { FileType } from '@office-start/document-types';
export function getFiltersMap(isMyContent, msaUserHint, isDesktopApp, identity) {
    var filtersArray = [
        isMyContent || !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? ['all', function (_doc) { return true; }]
            : undefined,
        !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? [
                'createdByMe',
                function (doc) {
                    var _a, _b;
                    return ((_a = doc.creatorUpn) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                        ((_b = identity === null || identity === void 0 ? void 0 : identity.userPrincipalName) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                },
            ]
            : [
                'createdByMe',
                function (doc) {
                    var _a;
                    return ((_a = doc.driveId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) ===
                        (msaUserHint === null || msaUserHint === void 0 ? void 0 : msaUserHint.toLowerCase());
                },
            ],
        ['recent', function (doc) { return !!doc.lastAccessedTime; }],
        ['shared', function (doc) { return !!doc.lastSharedTime; }],
        ['meetingRecordings', function (doc) { return !!doc.isMeetingRecording; }],
        [
            'playlists',
            function (doc) { return doc.fileType === FileType.PlayList; },
        ],
        [
            'favorites',
            function (doc) { return doc.isPinned || !!doc.savedForLaterDateTime; },
        ],
        isMyContent && !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? ['drafts', function (doc) { return doc.fileType === FileType.Draft; }]
            : undefined,
        isMyContent && !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? [
                'meetings',
                function (doc) {
                    return doc.fileType === FileType.MeetingObject;
                },
            ]
            : undefined,
        isMyContent && !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? [
                'cloudFiles',
                function (doc) {
                    return doc.isOneDriveForBusinessFile || doc.isSharePointFile;
                },
            ]
            : undefined,
        isMyContent && !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? [
                'people',
                function (doc) { return doc.isShared && !!doc.sharedByEmail; },
            ]
            : undefined,
        isMyContent && isPcPlatform() && !(identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? ['local', function (doc) { return doc.isLocalFile; }]
            : undefined,
        isMyContent
            ? ['attachments', function (doc) { return doc.isEmailAttachment; }]
            : undefined,
        isMyContent && (identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? [
                'oneDrive',
                function (doc) {
                    // Only show user's OneDrive documents for MSA
                    return !!doc.lastAccessedTime &&
                        !!doc.driveId &&
                        !doc.isLocalFile &&
                        doc.driveId.toLowerCase() ===
                            (msaUserHint === null || msaUserHint === void 0 ? void 0 : msaUserHint.toLowerCase());
                },
            ]
            : undefined,
        isMyContent && (identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? ['allLocations', function (doc) { return !!doc.lastAccessedTime; }]
            : undefined,
        isMyContent && (identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? [
                'otherCloud',
                function (doc) {
                    return !!doc.lastAccessedTime &&
                        !doc.driveId &&
                        !doc.isLocalFile;
                },
            ]
            : undefined,
        isMyContent && (identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? ['sharedFiles', function (doc) { return !!doc.lastSharedTime; }]
            : undefined,
        isMyContent && (identity === null || identity === void 0 ? void 0 : identity.isMsa)
            ? ['sharedPeople', function (doc) { return !!doc.lastSharedTime; }]
            : undefined,
        isMyContent && (identity === null || identity === void 0 ? void 0 : identity.isMsa) && isDesktopApp
            ? [
                'thisDevice',
                function (doc) {
                    return !!doc.lastAccessedTime && doc.isLocalFile;
                },
            ]
            : undefined,
    ].filter(function (val) { return !!val; });
    return new Map(filtersArray);
}
//# sourceMappingURL=getFiltersMap.js.map